/**
 * Aplicação de Riscos Ocupacionais (#606): o inventário comum (`InventarioDoDestino`) com a configuração de riscos — para
 * quem, o que já vale ali e o botão para adicionar mais, tudo gravado na hora.
 */
import { InventarioDoDestino } from '../../components/applications/InventarioDoDestino';
import { usePermissoesDaAplicacao } from '../../components/applications/permissoesDaAplicacao';
import { CONFIG_DE_RISCOS } from './configDeRiscos';

const MIGALHAS = [
  { label: 'Início', path: '/' },
  { label: 'Medicina', path: '/medicina' },
  { label: 'Aplicação de Riscos' },
];

export function RiskApplicationPage() {
  const permissoes = usePermissoesDaAplicacao('risk');
  return <InventarioDoDestino config={CONFIG_DE_RISCOS} breadcrumbs={MIGALHAS} permissoes={permissoes} />;
}

export default RiskApplicationPage;
